import React from "react";
import {
  Button,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  Typography,
  Stack,
} from "@mui/material";

import WindowIcon from "@mui/icons-material/Window";

function GridViewToolBar({
  tabValue,
  gridViewTabs,
  showGridView,
  setShowGridView,
  viewMode,
  viewModes,
  setViewMode,
  handleScroll,
}: {
  tabValue: string;
  gridViewTabs: string[];
  showGridView?: boolean;
  setShowGridView?: React.Dispatch<React.SetStateAction<boolean>>;
  viewMode?: string;
  viewModes?: string[];
  setViewMode?: React.Dispatch<React.SetStateAction<string>>;
  handleScroll: () => void;
}) {
  const getScrollLabel = (mode?: string) => {
    const viewLabels: Record<string, string> = {
      Statistics: "Statistics",
      None: "View",
    };
    if (!mode) return "Grid View";
    return viewLabels[mode] || `${mode} View`;
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{
        mr: 2,
        ml: 3,
        justifyContent: "flex-end",
        display: gridViewTabs.includes(tabValue) ? "flex" : "none",
      }}
    >
      <Button
        sx={{
          fontSize: "0.75rem",
          py: 1,
          backgroundColor: "primary.main",
          fontWeight: "bold",
        }}
        onClick={handleScroll}
        variant="contained"
        startIcon={<WindowIcon fontSize="small" />}
        size="large"
        disableElevation
        disabled={showGridView === false || viewMode === "None"}
      >
        {`Scroll to ${getScrollLabel(viewMode)}`}
      </Button>

      {viewMode ? (
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel id="view-select-label">View Mode</InputLabel>
          <Select
            labelId="view-select-label"
            value={viewMode}
            label="View Mode"
            onChange={(e) => setViewMode(e.target.value)}
          >
            {viewModes.map((mode, id) => (
              <MenuItem key={id} value={mode}>
                {mode}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <FormControlLabel
          control={
            <Switch
              checked={showGridView}
              onChange={() => setShowGridView((prev) => !prev)}
              color="primary"
              inputProps={{ "aria-label": "toggle visualization" }}
            />
          }
          label={
            <Typography variant="body2" fontWeight="bold">
              {"Grid Visualization"}
            </Typography>
          }
          labelPlacement="start"
        />
      )}
    </Stack>
  );
}

export default GridViewToolBar;
